import React, { useState, useContext, useEffect } from 'react'
import { IonMenuButton, IonTitle, IonToolbar, useIonModal, isPlatform, IonButton, IonButtons } from '@ionic/react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Context from '../context'
import Search from './Search'
import { enterAnimation, leaveAnimation } from '../utils/modal-animations'
import { getStoreHoursMessage } from '../utils/store'
import { distance as getDistance } from '../utils/distance'
import SVG from './SVG'

const Header: React.FC = () => {
  const { state } = useContext(Context)
  const router = useRouter()
  const [counterTotal, setCounterTotal] = useState(0)
  const [distance, setDistance] = useState<number>()

  useEffect(() => {
    const counter = state.cart.products?.reduce((prev, cur) => {
      return prev + cur.quantity
    }, 0)

    setCounterTotal(counter)
  }, [state.cart])

  useEffect(() => {
    if (state.cart.store && state.location?.lat && state.location?.lng) {
      try {
        setDistance(
          getDistance(
            state.location.lat,
            state.location.lng,
            state.cart.store.latitude,
            state.cart.store.longitude,
            'M'
          )
        )
      } catch (e) {
        console.error('error setting distance: ', e)
      }
    }
  }, [state.cart.store, state.location])

  const handleDismiss = () => dismiss()
  const [present, dismiss] = useIonModal(Search, { handleDismiss }
  )
  const toggleSearch = async () => {
    present({ cssClass: 'modal--search', enterAnimation, leaveAnimation })
  }

  const onHomeClick = () => {
    if (router.pathname === '/') {
      router.replace('/')
    } else {
      router.push('/')
    }
  }

  const isServer = typeof window === 'undefined'
  const isHomePage = useRouter().pathname === '/'
  if (!isServer) {
    return (
      <div className='header'>
        <IonToolbar>
          <IonButtons slot="start">
            {!isHomePage && isPlatform('pwa') && (
              <IonButton onClick={() => router.back()}>
                <SVG name='back' label='back button' size='md' />
              </IonButton>
            )}
            <IonMenuButton menu="mainContentId" autoHide={false}>
              <SVG name='menu' label='menu' size='md' />
              {!isPlatform('pwa') && <p>Menu</p>}
            </IonMenuButton>
            <Link href="/stores" className="header__store">
                <SVG
                  name={distance ? 'store-location' : 'store'}
                  label='store'
                  size='lg'
                />
                {state.cart.store && (
                  <div className="header__store-info">
                    <p className="header__store-address">
                      {state.cart.store.city?.toLowerCase()}, {state.cart.store.state?.toUpperCase()}
                    </p>
                    {getStoreHoursMessage(state.cart.store) && (
                      <p className="header__store-opening">
                        {distance
                          ? `${distance.toFixed(0)} mi away, ${getStoreHoursMessage(state.cart.store)}`
                          : getStoreHoursMessage(state.cart.store)}
                      </p>
                    )}
                  </div>
                )}
            </Link>
          </IonButtons>

          <IonButtons slot="end">
            <IonButton onClick={toggleSearch}>
              <SVG name='search' label='search' size='md' />
            </IonButton>
            <IonButton onClick={() => router.push('/cart')} className="header__cart">
              {counterTotal > 0 && (
                <div className="header__cart-counter">
                  {counterTotal}
                </div>
              )}
              <SVG name='cart' label='cart' size='md' />
            </IonButton>
          </IonButtons>

          <IonTitle>
            <IonButtons>
            <IonButton onClick={onHomeClick}>
              <SVG name='logo-color' label='logo' />
            </IonButton>
            </IonButtons>
          </IonTitle>
        </IonToolbar>
      </div>
    )
  } else {
    return (
      <div className="header"></div>
    )
  }
}

export default Header
